import styled from '@emotion/styled'
import { withClass } from '@news-mono/web-common'

import { calcRem } from '../../__styling/style-functions/calc-rem'
import { colors } from '../../__styling/settings/colors'
import { metrics } from '../../__styling/settings/metrics'
import { fonts } from '../../__styling/settings/fonts'

import { FundingLabel } from '../../advertising/FundingLabel/FundingLabel'
import { themedValue } from '../../__styling/themed-value'

export const StyledBylineClassName = 'CardByline'
export const StyledBylineTextClassName = 'CardByline-Text'
export const StyledHeadshotWrapperClassName = 'CardByline-HeadshotWrapper'

export interface StyledBylineProps {
    hasPadding: boolean
}

export const StyledByline = withClass(StyledBylineClassName)(
    styled('div')<StyledBylineProps>(
        {
            fontWeight: 400,
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: calcRem(8),
        },
        (props) => ({
            marginRight: calcRem(props.theme.margins.xs),
            padding: props.hasPadding
                ? themedValue(props.theme, {
                      thewest: calcRem(
                          0,
                          props.theme.cards.outerMargin,
                          props.theme.cards.outerMargin,
                          0,
                      ),
                      sevennews: calcRem(
                          0,
                          metrics.sevennews.cards.outerMargin,
                          metrics.sevennews.cards.outerMargin,
                          metrics.sevennews.cards.outerMargin,
                      ),
                      fallback: undefined,
                  })
                : undefined,
        }),
    ),
)

export const StyledBylineText = withClass(StyledBylineTextClassName)(
    styled('p')(
        {
            fontStyle: 'normal',
            marginTop: calcRem(16),
            margin: 0,
            alignSelf: 'center',
        },
        (props) => ({
            fontSize: themedValue(props.theme, {
                thewest: calcRem(12),
                sevennews: calcRem(14),
                perthnow: calcRem(14),
            }),
            fontFamily: themedValue(props.theme, {
                thewest: fonts.thewest.serif,
                sevennews: fonts.sevennews.sansSerif,
                fallback: undefined,
            }),
            fontWeight: themedValue(props.theme, {
                thewest: 500,
                fallback: 700,
            }),
        }),
    ),
)

export const StyledBylineTextWithHeadshot = styled(StyledBylineText)({
    width: `calc(100% - ${calcRem(53)} - ${calcRem(10)})`,
})

export const StyledBylineName = styled('span')(
    {
        fontWeight: 700, // Temporary while we work out getting proper font
        display: 'block',
        lineHeight: 1.2,
    },
    (props) => ({
        marginBottom: themedValue(props.theme, {
            thewest: props.theme.cards.textOffset,
            sevennews: metrics.sevennews.cards.textOffset,
            fallback: undefined,
        }),
    }),
)

export const StyledBylinePosition = styled('span')(
    {
        fontWeight: 400,
        display: 'block',
        lineHeight: 1.2,
    },
    (props) => ({
        color: themedValue(props.theme, {
            thewest: colors.thewest.greyGorilla,
            fallback: undefined,
        }),
    }),
)

export const StyledHeadshotWrapper = withClass(StyledHeadshotWrapperClassName)(
    styled('div')({
        display: 'block',
        borderRadius: '50%',
        marginRight: calcRem(10),
        overflow: 'hidden',
        width: calcRem(53),
        height: calcRem(53),
    }),
)

export const StyledHeadshot = styled('img')({
    width: calcRem(53),
    height: calcRem(53),
    filter: 'grayscale(100%)',
})

export const StyledFundingLabel = styled(FundingLabel)({}, (props) => ({
    display: 'block',
    width: themedValue(props.theme, {
        thewest: '100%',
        fallback: undefined,
    }),
}))
